import e from"style-inject";var n={mainContainer:"image-module_mainContainer__DYVBw"};e(".image-module_mainContainer__DYVBw {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}");export{n as default};
//# sourceMappingURL=image.module.scss.js.map
